import { Component, OnInit, Input } from '@angular/core';
import { ParamsService, CrudService } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { Company } from 'toolbandi-ui-lib';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-tool-list-filters',
	templateUrl: './tool-list-filters.component.html',
	styleUrls: ['./tool-list-filters.component.scss']
})
export class ToolListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	@Input()
	companyid: number;

	value = { from: undefined, to: undefined, min: 0, max: 1000000 };
	companies: Company[] = [];

	constructor(
		router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
		private companyService: CrudService<Company>
	) {
		super(router, _route, paramsService);

		this.companyService.getAll(Company, 'company').subscribe(data => this.companies = data);
	}

	ngOnInit() {
	}

	readQueryParams(params: string) {
		super.readQueryParams(params);
	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		this.value.from = undefined;
		this.value.to = undefined;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setValues();
		super.search(keeppage);
	}

	setValues(): void {
		if ((this.value.to || this.value.to === 0) && !this.value.from) this.value.from = this.value.min;
		if ((this.value.from || this.value.from === 0) && !this.value.to) this.value.to = this.value.max;

		if (this.value.from && this.value.from < this.value.min) this.value.from = this.value.min;
		if (this.value.to && this.value.to < this.value.min) this.value.to = this.value.min;
		if (this.value.from && this.value.from > this.value.max) this.value.from = this.value.max;
		if (this.value.to && this.value.to > this.value.max) this.value.to = this.value.max;

		this.searchparams.rangeTmp['value'] = { start: this.value.from, stop: this.value.to };

	}

}
